module.exports = __webpack_public_path__ + "img/out_in_yidong.3cc3be8e.jpg";